import React from "react";
import { motion } from "framer-motion";
import { GALLERY, CATS } from "../../data/pusheen";
import { useSound } from "../../sound/SoundContext";
import { burstFromEvent } from "../../lib/burst";

export default function Gallery() {
  const { play } = useSound();

  const boop = (e) => {
    play("pop");
    burstFromEvent(e, { count: 8, kinds: ["heart", "star"] });
  };

  const strip = [CATS.wave, CATS.cookie, CATS.heart, CATS.sleep, CATS.donut];

  return (
    <section id="gallery" className="relative z-10 py-20 sm:py-28 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }}
          className="text-center mb-14"
        >
          <p className="font-display font-bold text-pusheen-pink text-lg mb-2">the whole gang</p>
          <h2 className="font-script text-4xl sm:text-5xl text-pusheen-brown">The Pusheen Universe</h2>
          <p className="font-body text-pusheen-brownlight mt-2">tap a friend to say hi 🐾</p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {GALLERY.map((g, i) => (
            <motion.button
              key={g.title}
              onClick={boop}
              data-testid={`gallery-card-${i}`}
              initial={{ opacity: 0, y: 30, rotate: i % 2 ? 2 : -2 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: (i % 3) * 0.08, type: "spring", stiffness: 160, damping: 18 }}
              whileHover={{ y: -8, rotate: i % 2 ? -1 : 1 }}
              className="group text-left bg-white border-[3px] border-pusheen-brown rounded-3xl shadow-[5px_5px_0_#4A3728] hover:shadow-[8px_8px_0_#4A3728] transition-shadow p-6 flex flex-col items-center"
            >
              <div className="bg-[#FCF1E6] border-[3px] border-pusheen-brown rounded-2xl w-full aspect-square overflow-hidden mb-4">
                <img
                  src={g.src}
                  alt={g.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  draggable="false"
                />
              </div>
              <p className="font-display font-extrabold text-xl text-pusheen-brown">{g.title}</p>
              <p className="font-body text-pusheen-brownlight text-sm">{g.caption}</p>
            </motion.button>
          ))}

          {/* Join CTA tile */}
          <motion.div
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }}
            transition={{ type: "spring", stiffness: 160, damping: 18 }}
            className="bg-pusheen-pink border-[3px] border-pusheen-brown rounded-3xl shadow-[5px_5px_0_#4A3728] p-6 flex flex-col items-center justify-center text-center"
          >
            <p className="font-script text-3xl text-pusheen-brown">and you!</p>
            <p className="font-body text-pusheen-brown/80 mt-2">the fluffiest community on-chain is waiting.</p>
          </motion.div>
        </div>
      </div>

      {/* Marquee of paw-buddies */}
      <div className="mt-16 overflow-hidden border-y-[3px] border-pusheen-brown/20 py-6">
        <div className="flex w-max animate-marquee gap-12 pr-12">
          {[...strip, ...strip, ...strip, ...strip].map((s, i) => (
            <img key={i} src={s} alt="" className="w-16 sm:w-20 shrink-0 opacity-80" draggable="false" />
          ))}
        </div>
      </div>
    </section>
  );
}
